module.exports = __webpack_public_path__ + "img/logo.e968e3cd.png";